import { render, staticRenderFns } from "./ConsultasContainer.vue?vue&type=template&id=38af81a9&scoped=true"
import script from "./ConsultasContainer.vue?vue&type=script&lang=js"
export * from "./ConsultasContainer.vue?vue&type=script&lang=js"
import style0 from "./ConsultasContainer.vue?vue&type=style&index=0&id=38af81a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af81a9",
  null
  
)

export default component.exports